export enum ContractorCitationStatus {
  Open = 'Open',
  Resolved = 'Resolved'
}

export const CONTRACTOR_CITATION_STATUS_LABELS: Record<
  ContractorCitationStatus,
  string
> = {
  [ContractorCitationStatus.Open]: 'Open',
  [ContractorCitationStatus.Resolved]: 'Resolved'
};
